
$(document).ready(function() {
    var speed = 500;
    

    function showHideTabContent() {
        var $action = $('.js-tab-action');
        var tabContent = $('.js-tab-content');

        $action.on('click', function() {

            var $this = $(this);
            var _location = $this.attr('data-tab-location');
            var $location = $(''+_location+'');

            if(!$this.hasClass('js-active-tab')) {
                tabContent.removeClass('show-content');
                $location.addClass('show-content');
                $('.js-tab-action.js-active-tab').removeClass('js-active-tab');
                $this.addClass('js-active-tab');
            }            
        });
    }

    showHideTabContent();

});